import { Hero } from "../components/home/Hero";
import { AboutIntro } from "../components/home/AboutIntro";
import { ServicesGrid } from "../components/home/ServicesGrid";
import { EditorialMarquee } from "../components/home/EditorialMarquee";
import { WhyChooseUs } from "../components/home/WhyChooseUs";
import { IndustriesGrid } from "../components/home/IndustriesGrid";
import { CTASection } from "../components/home/CTASection";
import { FAQ } from "../components/home/FAQ";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <AboutIntro />
      <ServicesGrid />
      <EditorialMarquee />
      <WhyChooseUs />
      <IndustriesGrid />
      <CTASection />
      <FAQ />
    </main>
  );
}
